import CheckBoxV3 from "../../material/checkboxV3/CheckBoxV3";
import Recaptcha from "../../ReCaptcha";

const PolicyRegistration = ({
  permissionEmail,
  setPermissionEmail,

  personalInformation,
  setPersonalInformation,

  consentForm,
  setConsentForm,

  recaptchaCheck,
  handleRecaptchaChange,

  setOpenModalInformation, // open modal
  setOpenModalConsentForm, // open modal
  
}) => {
  return (
    <>
      <div className="flex justify-center w-full my-8">
        <div className="flex flex-col !items-start">
          <CheckBoxV3
            id="checkbox3"
            value={permissionEmail}
            setValue={setPermissionEmail}
            label={<p>ยอมรับการแจ้งเตือนเข้าสู่ระบบผ่าน Email</p>}
          />

          <CheckBoxV3
            id="checkbox1"
            value={personalInformation}
            setValue={setPersonalInformation}
            label={
              <p>
                ยอมรับ{" "}
                <span
                  className="text-blue-500 underline cursor-pointer"
                  onClick={() => setOpenModalInformation(true)}
                >
                  เงื่อนไขและนโยบายของการใช้งานเว็บไซต์
                </span>
              </p>
            }
          />

          <CheckBoxV3
            id="checkbox2"
            value={consentForm}
            setValue={setConsentForm}
            label={
              <p>
                ยอมรับ{" "}
                <span
                  className="text-blue-500 underline cursor-pointer"
                  onClick={() => setOpenModalConsentForm(true)}
                >
                  เงื่อนไขและนโยบายคุ้มครองข้อมูลส่วนบุคคล
                </span>
              </p>
            }
          />
        </div>
      </div>

      <div className="w-full flex justify-center my-4 flex-col items-center">
        {recaptchaCheck && (
          <span className=" text-center text-[red] text-[1rem] font-500 mb-4">
            กรุณายืนยันว่าเป็นบุคคล
          </span>
        )}
        <Recaptcha onChange={handleRecaptchaChange} />
      </div>
    </>
  );
};

export default PolicyRegistration;
